/**
 * Order and related type definitions
 * 
 * These types are used throughout the application for order management.
 */


export enum DispatchState {
    Candidate = 'candidate',
    Scheduled = 'scheduled',
    Posted = 'posted',
    Cancelled = 'cancelled',
}

export enum RxStatus {
    WAITING = 'waiting',
    CALL_IN_PROGRESS = 'call-in-progress',
    COMPLETED = 'completed',
}


export interface WindowBucket {
    start: number;
    end: number;
    label?: string;
    type?: string;
    /** Exact start in minutes from midnight; absent on hour-only windows */
    startMinutes?: number;
    endMinutes?: number;
}

export type Outcome =
    | 'answered'
    | 'confirmed'
    | 'confirmed_with_voicemail'
    | 'alt_window'
    | 'reschedule'
    | 'no_answer'
    | 'voicemail'
    | 'transfer'
    | 'cancelled';

/** Lock status as returned from API (dates as ISO strings) */
export interface OrderLockStatus {
  isBlocked?: boolean;
  blockedBy?: string;
  expiresAt?: string;
  blockedAt?: string;
}

export interface Order {
    id: string;
    sm_number: string;
    patient_name: string;
    address: string;
    ship_to_city: string;
    postal_code: string;
    locationCode?: string;
    phone: string;
    raw_phone?: string;
    ai_inferred_phone?: string;
    ship_to_phone_no?: string;
    phone_secondary?: string;
    raw_phone_secondary?: string;
    ai_inferred_phone_secondary?: string;
    id_required: boolean;
    patient_id: string;
    shipping_agent_code: string | null;
    delivery_date: string;
    requested_delivery_date?: string;
    nav_status: string;
    preferred_window?: WindowBucket | null;
    original_window?: WindowBucket | null;
    time_required?: string;
    white_glove_service: boolean;
    rxStatus?: string;
    clientId?: string;
    updatedAt?: string;
    lockStatus?: OrderLockStatus;
    isBlocked?: boolean;
    isBlockedBy?: string;
    lockExpiresAt?: string;
    to_be_dispatched?: boolean;
    dispatch_state?: DispatchState;
    last_outcome?: Outcome;
    last_window?: WindowBucket | null;
    last_called_at?: number;
    transfer_reason?: string;
    cancellation_reason?: string;
    cancellation_type?: string;
    retry_count?: number;
    next_retry_at?: Date;
}

export interface CallBlock {
    id: number;
    order_ids: string[];
    time_window: WindowBucket;
    status: 'calling' | 'review' | 'closed';
    created_at: number;
}

export interface CallAttempt {
    order_id: string;
    timestamp: number;
    outcome?: Outcome;
    window?: WindowBucket;
    new_delivery_date?: string;
    transfer_reason?: string;
    attempt_no?: number;
    voicemail_message_type?: string;
    call_duration_seconds?: number;
    rings_before_answer?: number;
    customer_response_detected?: boolean;
    needs_callback?: boolean;
}
